import { useParams } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { getApi } from 'views/services/api';
import { useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import AddItems from 'views/restaurant/AddItems';
import DeleteFoodItem from './DeleteItem';
import EditIcon from '@mui/icons-material/Edit';
import EditQuantity from './EditQuantity';

// ----------------------------------------------------------------------

const ShowAllFoodItem = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [itemsData, setitemsData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [foodId, setFoodId] = useState('');
  const [foodData, setFoodData] = useState('');
  const params = useParams();
  const reservationId = params.id;

  // // function for fetching all the restaurant items data from the db
  const fetchitemsData = async () => {
    try {
      const response = await getApi(`api/reservation/getfooditems/${reservationId}`);
      console.log("yyyyy =>",response);
      
      setitemsData(response?.data?.foodItemsData[0]?.foodItems);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchitemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openDelete, openEdit]);

  // function for opening dialogs---------------------------
  const handleOpenDeleteItem = (itemId) => {
    setFoodId(itemId);
    setOpenDelete(true);
  };
  const handleCloseAdd = () => setOpenAdd(false);
  const handleCloseDeleteItem = () => setOpenDelete(false);

  const handleOpenEditQuantity = (foodData) => {
    setFoodData(foodData);
    setOpenEdit(true);
  };

  const handleCloseEditQuantity = () => {
    setOpenEdit(false);
  };
  //-----------------------------------------------

  const columns = [
    {
      field: 'itemImage',
      headerName: 'Item Image',
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            <img src={params?.value} alt="item" style={{ width: '40px', height: '40px', borderRadius: '10px', }}
            />
          </div>
        );
      }
    },
    {
      field: 'name',
      headerName: 'Item Name',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },

    {
      field: 'price',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params?.value}</Box>;
      }
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      flex: 1
    },
    {
      field: 'totalAmountFood',
      headerName: 'Total Amount',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params?.value}</Box>;
      }
    },

    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <MenuItem onClick={() => handleOpenEditQuantity(params?.row)} disableRipple>
              <EditIcon style={{ marginRight: '8px' }} />
              Edit
            </MenuItem>
            <MenuItem onClick={() => handleOpenDeleteItem(params?.row?.id)} sx={{ color: 'red' }} disableRipple>
              <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
            </MenuItem>
          </>
        );
      }
    }
  ];

  return (
    <>
      <EditQuantity open={openEdit} handleClose={handleCloseEditQuantity} data={foodData} />
      <AddItems open={openAdd} handleClose={handleCloseAdd} />
      <DeleteFoodItem open={openDelete} handleClose={handleCloseDeleteItem} data={foodId} />
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}></Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <Typography variant="h4" sx={{ margin: '2px 15px' }}>
                Food items ( {itemsData?.length || 0} )
              </Typography>
              {itemsData?.length > 0 && (
                <DataGrid
                  rows={itemsData}
                  columns={columns}
                  getRowId={(row) => row.id}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{ toolbar: { showQuickFilter: true } }}
                  rowHeight={60}
                />
              )}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default ShowAllFoodItem;
